import React, { createContext, useEffect } from 'react';
import { lightTheme, darkTheme } from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { updatePreferences } from 'store/Preferences/actions';
import { selectPreferences } from 'store/Preferences/selectors';
import { get } from 'lodash';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const preferences = useSelector(selectPreferences);
  const theme = get(preferences, 'theme', 'light');
  const dispatch = useDispatch();

  useEffect(() => {
    if (!theme) return;
    const root = document.getElementById('root');
    if (!root) return;

    root.classList.remove('light-theme', 'dark-theme');

    root.classList.add(`${theme}-theme`);
  }, [theme]);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    dispatch(updatePreferences({ theme: newTheme }));
  };

  const resetTheme = () => {
    dispatch(updatePreferences({ theme: 'light' }));
  };

  const setParticularTheme = (particularTheme) => {
    dispatch(updatePreferences({ theme: particularTheme }));
  };

  return (
    <ThemeContext.Provider
      value={ {
        theme,
        toggleTheme,
        resetTheme,
        setParticularTheme,
        themeStyles: theme === 'light' ? lightTheme : darkTheme
      } }
    >
      {children}
    </ThemeContext.Provider>
  );
};
